import React from 'react';
import { useContactInfo } from '../hooks/useContentful';

const WhatsAppFloat = () => {
  const { contactInfo, loading, error } = useContactInfo();

const whatsappNumber = contactInfo?.whatsappNumber?.replace(/\D/g, ''); // Remueve símbolos no numéricos
const encodedMessage = encodeURIComponent(contactInfo?.whatsappMessage || '');
const whatsappUrl = `https://wa.me/${whatsappNumber}?text=${encodedMessage}`;
 

  return (
    <div className="fixed bottom-4 right-4 md:bottom-6 md:right-6 z-50 group">
      <a 
        href={whatsappUrl}
        target="_blank" 
        rel="noopener noreferrer"
        className="bg-[#25D366] hover:bg-[#1ebe5d] text-white rounded-full p-3 md:p-4 shadow-lg flex items-center justify-center w-14 h-14 md:w-16 md:h-16 transition-all duration-300 transform hover:scale-110 animate-pulse hover:animate-none relative overflow-hidden"
        title="Chatea con nosotros por WhatsApp"
      >
        {/* Ripple effect */}
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-20"></div>
        <div className="absolute inset-0 rounded-full bg-[#25D366] animate-ping opacity-10" style={{animationDelay: '0.5s'}}></div>
        
        <i className="fab fa-whatsapp text-2xl md:text-3xl relative z-10"></i>
        
        {/* Tooltip - hidden on mobile */}
        <div className="hidden md:block absolute right-full mr-3 top-1/2 transform -translate-y-1/2 bg-gray-800 text-white px-3 py-2 rounded-lg text-sm whitespace-nowrap opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
          ¡Chatea con nosotros!
          <div className="absolute left-full top-1/2 transform -translate-y-1/2 border-4 border-transparent border-l-gray-800"></div>
        </div>
      </a>
    </div>
  );
};

export default WhatsAppFloat;